<template>
    <CampaignBanner
        class="variants-banner"
        :master-template-height="deliverable.masterTemplate.height"
        :master-template-width="deliverable.masterTemplate.width"
        :max-height="maxHeight"
        :max-width="maxWidth"
        :scaling-factor="scalingFactor"
        @updateInternalScalingFactor="internalScalingFactor = $event"
    >
        <template #bannerContainer>
            <BannerPreview
                :id="bannerId"
                lazy-load
                :preview-values="previewValues(deliverable)"
                :ad-type="deliverable.masterTemplate.adType"
                :scaling-factor="internalScalingFactor"
                :playback-namespace="playbackNamespace"
            />
        </template>

        <template #bannerFooter>
            <BannerFooterName :is-dark-theme="false" :banner-name="bannerName" />
        </template>
    </CampaignBanner>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import type { ConstructedDeliverable } from "@/types/types";
import { BannerEvents } from "@/enums/banners";

import BannerPreview from "@/components/Previews/BannerPreview.vue";
import CampaignBanner from "@/components/Campaign/CampaignBanner.vue";
import BannerFooterName from "@/components/Previews/BannerFooter/BannerFooterName.vue";

import { getBannerIdFromDeliverable } from "@/utils/getBannerIframeId";
import { usePreviewValues } from "@/composables/usePreviewValues";

export default defineComponent({
    components: {
        CampaignBanner,
        BannerPreview,
        BannerFooterName
    },

    props: {
        deliverable: {
            type: Object as PropType<ConstructedDeliverable>,
            required: true
        },

        scalingFactor: {
            type: Number,
            required: true
        },

        maxHeight: {
            type: Number,
            required: true
        },

        maxWidth: {
            type: Number,
            required: true
        },

        playbackNamespace: {
            type: String,
            required: true
        }
    },

    emits: [BannerEvents.BannerLoaded],

    setup() {
        const previewValues = usePreviewValues();

        return {
            previewValues
        };
    },

    data() {
        return {
            internalScalingFactor: this.scalingFactor
        };
    },

    computed: {
        bannerId() {
            return getBannerIdFromDeliverable(this.deliverable, this.playbackNamespace);
        },

        bannerName() {
            return (
                this.deliverable.reportingLabel ??
                `${this.deliverable.masterTemplate.width} x ${this.deliverable.masterTemplate.height} - ${this.deliverable.masterTemplate.name}`
            );
        }
    }
});
</script>
